import React from "react";

// Distinct "+ Add custom field" ghost button — adds a static/hardcoded
// key/value row, not a drag interaction.
export function AddCustomFieldButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        marginTop: 12,
        padding: "8px 14px",
        background: "transparent",
        color: "#626262",
        border: "1px dashed #E2E2E2",
        borderRadius: 8,
        fontSize: 12,
        cursor: "pointer",
        width: "100%",
      }}
    >
      + Add custom field
    </button>
  );
}
